module.exports = __webpack_public_path__ + "static/media/login-hero.693061ed.png";